import React, { useState, useEffect } from 'react';

/**
 * Filter bar for the Firebase Feedback tab (feature 067-user-feedback-tabs).
 *
 * Same `au-` filter system, same control order and the same in-bar Export as the other three
 * tabs, so switching between them does not mean relearning the screen.
 *
 * The RATING selector is the one control with no analogue on the sibling tabs. It earns its place
 * because rating is the only structured signal this source carries — "show me the ones and twos"
 * is the question an admin actually opens this tab to ask.
 *
 * "Unrated" is a distinct choice rather than a rating of 0: 45 of 154 documents predate the app
 * asking, and lumping them in with the lowest score would be a lie about how members felt.
 */
const EMPTY = { search: '', from: '', to: '', rating: '' };

export default function FirebaseFeedbackFilters({ values, onApply, onClear, onExport }) {
  const [local, setLocal] = useState({ ...EMPTY, ...values });
  useEffect(() => { setLocal({ ...EMPTY, ...values }); }, [values]);

  const set = (k, v) => setLocal((p) => ({ ...p, [k]: v }));
  const submit = (e) => { if (e) e.preventDefault(); onApply(local); };

  return (
    <form className="au-filters ff-filters" aria-label="Feedback filters" onSubmit={submit}>
      {/* The fields wrap among themselves; the actions never leave their row. */}
      <div className="au-filters__fields">
        <div className="au-field ff-field-grow">
          <span className="au-field__label">Search</span>
          <input
            aria-label="Search feedback"
            className="au-input"
            placeholder="Name, email, title or message"
            value={local.search}
            onChange={(e) => set('search', e.target.value)}
          />
        </div>

        <div className="au-field">
          <span className="au-field__label">Rating</span>
          <select
            aria-label="Rating"
            className="au-select"
            value={local.rating}
            onChange={(e) => set('rating', e.target.value)}
          >
            <option value="">All ratings</option>
            <option value="5">5</option>
            <option value="4">4</option>
            <option value="3">3</option>
            <option value="2">2</option>
            <option value="1">1</option>
            <option value="unrated">Unrated</option>
          </select>
        </div>

        <div className="au-field">
          <span className="au-field__label">From</span>
          <input
            aria-label="From date"
            className="au-select"
            type="date"
            value={local.from}
            onChange={(e) => set('from', e.target.value)}
          />
        </div>

        <div className="au-field">
          <span className="au-field__label">To</span>
          <input
            aria-label="To date"
            className="au-select"
            type="date"
            value={local.to}
            onChange={(e) => set('to', e.target.value)}
          />
        </div>

      </div>

      <div className="au-field au-field--actions ff-actions">
        <button type="submit" className="au-btn au-btn--primary">Apply</button>
        <button
          type="button"
          className="au-btn au-btn--ghost"
          onClick={() => { setLocal({ ...EMPTY }); onClear(); }}
        >
          Clear
        </button>
        <button type="button" className="au-btn au-btn--ghost" onClick={onExport}>⬇ Export CSV</button>
      </div>
    </form>
  );
}
